<div class="card" [ngStyle]="mainStyle">
    <div class="header">
        <ng-content select="[header]"></ng-content>
    </div>
    <div class="separator">
        <ng-content select="[separator]"></ng-content>
    </div>
    <div class="content">
        <ng-content select="[content]"></ng-content>
    </div>
</div>